/**
 * read variables from sass/compass which were written in vars.scss.
 * vars.css must be inlined as <style id="css-vars">
 */

// read css variables
var sheet = $('#css-vars').prop('sheet');
if (!sheet) {
	$.each(document.styleSheets, function(index, _sheet) {
		if (_sheet.id === 'css-vars') {
			sheet = _sheet;
		}
	});
}

var rules = sheet.rules || sheet.cssRules;
var values = rules[0].style.content;
// strip quotes
values = values.replace(/^('|")(.*)('|")$/, '$2');
values = values.replace(/\\"/g, '"');

module.exports = $.parseJSON(values);
